import React from 'react';

const ParentPortfolioIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M11.1382 2.81543C11.7424 2.5638 12.4226 2.56465 13.0269 2.81641L21.6421 6.40625C23.0596 6.99689 23.0596 9.00409 21.6421 9.59473L20.5864 10.0342L21.478 10.4053C22.8954 10.996 22.8953 13.003 21.478 13.5938L20.5024 13.999L21.478 14.4053C22.8954 14.996 22.8953 17.003 21.478 17.5938L12.8618 21.1846C12.2577 21.4361 11.5772 21.4362 10.9731 21.1846L2.35693 17.5938C0.940274 17.0029 0.940331 14.9962 2.35693 14.4053L3.33057 13.999L2.35693 13.5938C0.940274 13.0029 0.940331 10.9962 2.35693 10.4053L3.41162 9.96582L2.521 9.59473C1.10447 9.00379 1.10446 6.99717 2.521 6.40625L11.1382 2.81543ZM12.8618 17.1846C12.2577 17.4361 11.5772 17.4362 10.9731 17.1846L5.9292 15.082L3.729 16L11.7427 19.3389C11.8546 19.3854 11.9813 19.3845 12.0933 19.3379L20.106 16L17.9048 15.082L12.8618 17.1846ZM3.729 12L11.7427 15.3389C11.8546 15.3854 11.9813 15.3845 12.0933 15.3379L20.106 12L17.9878 11.1172L13.0269 13.1846C12.4226 13.4363 11.7424 13.4372 11.1382 13.1855L6.01025 11.0479L3.729 12ZM12.2573 4.66211C12.1453 4.61548 12.0187 4.6155 11.9067 4.66211L3.89307 8.00098L11.9067 11.3389C12.0187 11.3855 12.1453 11.3855 12.2573 11.3389L20.27 8.00098L12.2573 4.66211Z"
      fill="#27B0E0"
    />
  </svg>
);

export default ParentPortfolioIcon;
